import React from 'react'
import CTA from "./CTA";
import './header.css'

const Header = () => {
    return (
        <header>
            <div className="container header__container">
                <h5>Hello I'm</h5>
                <h1>Anastasiia Kubrak</h1>
                <h5 className="text-light">PHOTOGRAPHER</h5>
                <CTA />
                {/* <HeaderSocials />
                <div className="me">
                    <img src={ME} alt="me"/>
                </div>
                <a href="#contact" className="scroll__down">Scroll down</a> */}
            </div>
        </header>
    )
}
export default Header
